import { useRoutes } from "react-router-dom";

import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import AdminRoutes from "./AdminRoutes";
import ErrorsRoutes from "./ErrorsRoutes";

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, AdminRoutes, LoginRoutes, ErrorsRoutes]);
}
